/**
 * FleetMap — ícone canônico de equipamento (fonte única).
 *
 * Extraído de DashboardPage (ADR-2026-05-29-shared-fleetmap-component, Fase 1).
 * Renderiza o glifo do equipamento + linhas de direção: proa (heading) verde
 * sólida e curso sobre o solo (COG) laranja tracejada, com 30% de transparência.
 * Anel ciano quando "seguido" (modo Seguir).
 *
 * IMPORTANTE (INV-UI-TRAIL-001): apenas apresentação — heading/cog/speed chegam
 * já convertidos do backend; nenhum recomputo de unidade aqui.
 *
 * `buildEquipmentIconSvg` é puro (sem Leaflet) → testável; `createEquipmentIcon`
 * embrulha em L.divIcon.
 */

import L from 'leaflet';

export const MARKER_COLORS = {
  green: '#22c55e',
  yellow: '#eab308',
  red: '#ef4444',
  blue: '#0ea5e9',
  gray: '#64748b',
};

export const customIconSvgs = {
  ship: `<path d="M3 15 L5 19 L19 19 L21 15 L3 15" /><rect x="7" y="10" width="10" height="5" /><rect x="9" y="6" width="6" height="4" /><rect x="15" y="4" width="2" height="6" /><path d="M16 4 C16 2 18 2 18 4" /><path d="M2 21 C4 20 6 22 8 21 C10 20 12 22 14 21 C16 20 18 22 20 21" />`,
  dredge: `<path d="M2 16 L4 18 L20 18 L22 16 L2 16" /><path d="M2 16 L2 13 L5 13" /><rect x="4" y="10" width="4" height="6" /><path d="M5 11 L7 11" /><path d="M6 10 L6 6" /><circle cx="13" cy="12" r="4" /><path d="M13 8 L13 16" /><path d="M9 12 L17 12" /><circle cx="13" cy="12" r="1" /><path d="M18 10 L18 7 L19 7 L19 10" /><path d="M20 14 L22 15 L22 17" /><path d="M1 20 C3 19 5 21 7 20 C9 19 11 21 13 20 C15 19 17 21 19 20" />`,
  loader: `<rect x="10" y="6" width="6" height="6" rx="1" /><path d="M8 12 L18 12 L18 16 L8 16 Z" /><path d="M10 10 L4 6 L2 8 L6 12" /><path d="M2 8 L1 5 L5 4 L4 6" /><circle cx="15" cy="18" r="3" /><circle cx="7" cy="18" r="2.5" />`,
  engine: `<path d="M2 20 L22 20" /><path d="M3 20 L3 18" /><path d="M21 20 L21 18" /><rect x="3" y="10" width="8" height="8" rx="1" /><path d="M4 10 L4 8 L10 8 L10 10" /><path d="M5 8 L5 6 L9 6 L9 8" /><path d="M3 11 L1 11 L1 14" /><rect x="11" y="12" width="2" height="4" /><ellipse cx="17" cy="14" rx="4" ry="4" /><ellipse cx="17" cy="14" rx="2.5" ry="2.5" /><circle cx="17" cy="14" r="1" /><rect x="19" y="10" width="3" height="3" /><rect x="14" y="6" width="5" height="3" />`,
  car: `<path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/>`,
  truck: `<path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>`,
  settings: `<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>`,
};

export const getIconKeyFromTypeName = (typeName) => {
  if (!typeName) return 'settings';
  const name = typeName.toLowerCase();
  if (name.includes('rebocador') || name.includes('ship') || name.includes('embarcação')) return 'ship';
  if (name.includes('draga')) return 'dredge';
  if (name.includes('carregadeira') || name.includes('loader')) return 'loader';
  if (name.includes('motor') || name.includes('estacionário') || name.includes('engine')) return 'engine';
  if (name.includes('caminhão') || name.includes('truck')) return 'truck';
  if (name.includes('veículo') || name.includes('leve') || name.includes('car')) return 'car';
  return 'settings';
};

// Geometria: canvas ampliado para acomodar linhas de direção longas sem corte.
export const ICON_SIZE = 208;
const C = ICON_SIZE / 2; // centro (104)
const LINE = 100;        // comprimento das linhas de direção
const HEADING_COLOR = '#4ade80'; // proa, verde claro (distinta do trail roxo)
const COG_COLOR = '#f97316';     // curso sobre o solo, laranja
const FOLLOW_RING_COLOR = '#38bdf8';

/**
 * Constrói o HTML/SVG do ícone (PURO — sem Leaflet, testável).
 */
export const buildEquipmentIconSvg = (typeName, markerColor, heading, cog, speedKnots, isFollowed = false) => {
  const color = MARKER_COLORS[markerColor] || MARKER_COLORS.gray;
  const bgColor = `${color}33`;
  const svgPath = customIconSvgs[getIconKeyFromTypeName(typeName)] || customIconSvgs.settings;

  const directionLine = (deg, strokeColor, dashArray) =>
    `<line x1="${C}" y1="${C}" x2="${C + LINE * Math.sin((deg * Math.PI) / 180)}" y2="${C - LINE * Math.cos((deg * Math.PI) / 180)}" stroke="${strokeColor}" stroke-width="3" stroke-linecap="round" stroke-opacity="0.7"${dashArray ? ` stroke-dasharray="${dashArray}"` : ''}/>`;
  const headingLine = heading != null ? directionLine(heading, HEADING_COLOR, '') : '';
  const showCog = cog != null && speedKnots != null && speedKnots > 0.5;
  const cogLine = showCog ? directionLine(cog, COG_COLOR, '5 3') : '';
  const followRing = isFollowed
    ? `<circle cx="${C}" cy="${C}" r="24" fill="none" stroke="${FOLLOW_RING_COLOR}" stroke-width="2" stroke-dasharray="3 3"/>`
    : '';

  return `
      <svg width="${ICON_SIZE}" height="${ICON_SIZE}" viewBox="0 0 ${ICON_SIZE} ${ICON_SIZE}" xmlns="http://www.w3.org/2000/svg">
        ${cogLine}
        ${headingLine}
        ${followRing}
        <circle cx="${C}" cy="${C}" r="18" fill="${bgColor}" stroke="${color}" stroke-width="2" style="pointer-events:auto;cursor:pointer"/>
        <svg x="${C - 10}" y="${C - 10}" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="pointer-events:auto;cursor:pointer">
          ${svgPath}
        </svg>
      </svg>
    `;
};

/**
 * Cria o L.divIcon do equipamento (wrapper do builder puro).
 */
export const createEquipmentIcon = (typeName, markerColor, heading, cog, speedKnots, isFollowed = false) =>
  L.divIcon({
    className: 'custom-equipment-marker',
    html: buildEquipmentIconSvg(typeName, markerColor, heading, cog, speedKnots, isFollowed),
    iconSize: [ICON_SIZE, ICON_SIZE],
    iconAnchor: [C, C],
    popupAnchor: [0, -22],
  });
